import { render, staticRenderFns } from "./POLineItemDetails.vue?vue&type=template&id=28601fed&scoped=true"
import script from "./POLineItemDetails.vue?vue&type=script&lang=js"
export * from "./POLineItemDetails.vue?vue&type=script&lang=js"
import style0 from "./POLineItemDetails.vue?vue&type=style&index=0&id=28601fed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28601fed",
  null
  
)

export default component.exports